import userHasCustomTourOperatorsOverwrite from './userHasCustomTourOperatorsOverwrite'
import userHasCustomTourOperatorCode from './userHasCustomTourOperatorCode'
import { userCustomTourOperatoreCode as userCustomTOPCodeSessionKey } from '../../config/sessionStorage'

export default () => {
  if (!userHasCustomTourOperatorsOverwrite()) return undefined

  return userHasCustomTourOperatorCode()
    ? sessionStorage[userCustomTOPCodeSessionKey]
    : undefined
}
